import React, { useState, useEffect } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import useAdminRequest from '../../../requests/AdminRequest';
import Loader from '../../common/Loader';
import MuxIdDrilldownTableRow from './MuxIdDrilldownTableRow';
import RouteNameDrilldown from './RouteNameDrilldown';
import RouteIdDrilldown from './RouteIdDrilldown';

const MuxIdDrilldown = (props) => {
  const [statsByMuxId, setStatsByMuxId] = useState([]);
  const [selectedRouteName, setSelectedRouteName] = useState(null);
  const [selectedRouteId, setSelectedRouteId] = useState(null);
  const { getDaemonConfigByRouteName, getRecentMessagesByRouteId } =
    useAdminRequest();

  useEffect(() => {
    getValues();
  }, [props.selectedMuxID, props.isTwilio]);

  const getValues = async () => {
    let statsByMuxId = await props.getMuxIdDrilldown(
      props.selectedMuxID,
      props.isTwilio
    );
    setStatsByMuxId(statsByMuxId);
  };

  const getRouteNameDrilldown = async (routeName) => {
    try {
      let daemonConfig = await getDaemonConfigByRouteName(
        routeName,
        props.errorHandler
      );
      return daemonConfig;
    } catch (e) {
      console.log(e);
    }
  };

  const getRouteIdDrilldown = async (routeId) => {
    try {
      let recentMessages = await getRecentMessagesByRouteId(
        routeId,
        props.errorHandler
      );
      return recentMessages;
    } catch (e) {
      console.log(e);
    }
  };

  const drilldownRouteName = (e) => {
    setSelectedRouteName(e);
  };

  const drilldownRouteId = (e) => {
    setSelectedRouteId(e);
  };

  const backToMuxIdDrilldown = () => {
    setSelectedRouteName(null);
    setSelectedRouteId(null);
  };

  const generateContent = () => {
    return (
      <>
        <Typography variant="h3">{props.selectedMuxId}</Typography>
        {generateTable()}
      </>
    );
  };

  const generateTable = () => {
    if (selectedRouteName) {
      return (
        <RouteNameDrilldown
          selectedRouteName={selectedRouteName}
          backToMuxIdDrilldown={backToMuxIdDrilldown}
          getRouteNameDrilldown={getRouteNameDrilldown}
        />
      );
    } else if (selectedRouteId) {
      return (
        <RouteIdDrilldown
          selectedRouteId={selectedRouteId}
          backToMuxIdDrilldown={backToMuxIdDrilldown}
          getRouteIdDrilldown={getRouteIdDrilldown}
        />
      );
    } else {
      if (statsByMuxId && statsByMuxId.length > 0) {
        return (
          <Box>
            <Button
              onClick={() => props.backToStats()}
              variant="link"
              startIcon={<ArrowBackIcon />}
            >
              <Typography>Back</Typography>
            </Button>

            <Typography variant="h3" gutterBottom>
              Detailed Stats - {statsByMuxId[0] ? statsByMuxId[0].mux_id.S : ''}
              {props.isTwilio ? '(Twilio)' : ''}
            </Typography>

            <TableContainer sx={{ marginBottom: 4, overflowX: 'auto' }}>
              <Table width="100%">
                <TableHead>
                  <TableRow className="tableTop column-right">
                    <TableCell>MuxId</TableCell>
                    <TableCell>RouteName</TableCell>
                    <TableCell>RouteID</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Protocol</TableCell>
                    <TableCell>TX_OK</TableCell>
                    <TableCell>TX_ERR</TableCell>
                    <TableCell>RX</TableCell>
                    <TableCell>Today</TableCell>
                    <TableCell>H</TableCell>
                    <TableCell>M</TableCell>
                    <TableCell>L</TableCell>
                    <TableCell>Age (s)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>{generateTableBody()}</TableBody>
              </Table>
            </TableContainer>
          </Box>
        );
      } else {
        return <Loader />;
      }
    }
  };

  /*
    Generates the body of the Table/List to display all Provider data
  */
  const generateTableBody = () => {
    let rows = [];
    for (let i = 0; i < statsByMuxId.length; i++) {
      rows.push(
        <MuxIdDrilldownTableRow
          key={statsByMuxId[i].route_name.S}
          id={statsByMuxId[i].route_name.S}
          muxId={statsByMuxId[i].mux_id.S}
          routeName={statsByMuxId[i].route_name.S}
          routeId={statsByMuxId[i].route_id.S}
          daemonStatus={statsByMuxId[i].daemon_status.S}
          protocol={statsByMuxId[i].protocol.S}
          txOk={statsByMuxId[i].transmitted_ok.N}
          txErr={statsByMuxId[i].transmitted_error.N}
          rx={statsByMuxId[i].received.N}
          today={statsByMuxId[i].sms_today.N}
          maxPerDay={statsByMuxId[i].max_sms_per_day.N}
          H={statsByMuxId[i].messages_count_H.N}
          M={statsByMuxId[i].messages_count_M.N}
          L={statsByMuxId[i].messages_count_L.N}
          age={statsByMuxId[i].updated_at.S}
          onClickRouteName={(e) => drilldownRouteName(e)}
          onClickRouteId={(e) => drilldownRouteId(e)}
        />
      );
    }
    return rows;
  };

  return generateContent();
};

export default MuxIdDrilldown;
